import React, { useState } from "react";
import {
  FlexCenterColumn,
  StyledArrow,
  UserMenu,
  UsermenuItem,
  Usernamediv,
} from "./Layout";
import { StyledLogoutIcon } from "../AppStyle";
import { faAngleDown, faAngleUp } from "@fortawesome/free-solid-svg-icons";

export const Usermenu = ({ user }) => {
  const [showMenu, setShowMenu] = useState(false);

  return (
    <FlexCenterColumn
      onMouseOver={() => {
        setShowMenu(true);
      }}
      onMouseLeave={() => {
        setShowMenu(false);
      }}
      onClick={() => {
        setShowMenu(!showMenu);
      }}
    >
      <Usernamediv>
        {/* <StyledMenu mode="inline" items={items} /> */}
        <a>{user}</a>
        {showMenu === true ? (
          <StyledArrow icon={faAngleDown} />
        ) : (
          <StyledArrow icon={faAngleUp} />
        )}
      </Usernamediv>

      {showMenu && (
        <UserMenu
          onClick={() => {
            setShowMenu(!showMenu);
          }}
        >
          <UsermenuItem
            onClick={() => {
              window.location.href = `/web/session/logout?redirect=/`;
            }}
          >
            <span>{"Logout"}</span>
            <StyledLogoutIcon />
          </UsermenuItem>
        </UserMenu>
      )}
    </FlexCenterColumn>
  );
};
